import * as THREE from "three";

/**
 * Simple extended THREE.Mesh that loads a textured
 * with the loadTexture method
 */
export default class TexturedMesh extends THREE.Mesh {
  /**
   * Creates mesh using given geometry
   *
   * @param {Player} player
   * @param {THREE.Geometry} geometry
   * @param {string} materialType
   */
  constructor(player, geometry, materialType = "basic") {
    let material;

    switch (materialType) {
      case "phong":
        material = new THREE.MeshPhongMaterial();
        break;
      default:
        material = new THREE.MeshBasicMaterial();
        break;
    }

    material.map = new THREE.TextureLoader().load();
    material.map.anisotropy =
      "renderer" in player
        ? player.renderer.capabilities.getMaxAnisotropy()
        : null;
    material.map.minFilter = material.map.magFilter = THREE.LinearFilter;
    super(geometry, material);
    material.dispose();
    geometry.dispose();
    this.player = player;
    this.loaded = false;
  }

  setTexture(texture) {
    if (
      texture &&
      "material" in this &&
      this.material !== undefined &&
      "map" in this.material
    ) {
      this.material.dispose();
      this.material.map.dispose();
      this.material.map = texture;
    } else {
      if (this.material === undefined) {
        console.warn("Could not set texture, material is undefined");
      } else {
        throw Error("Could not set texture");
      }
    }
  }

  async getTexture(
    image,
    flip,
    callback = () => { },
    stereo,
    lowRes,
    resolution,
  ) {
    return await new Promise((resolve, reject) => {
      if (this.player.textureManager?.fetch) {
        this.player.textureManager.fetch({
          image,
          flip,
          callback: ({ texture, full, res }) => {
            callback(texture, full, res);
            resolve(texture);
          },
          nonCritical: false,
          stereo,
          lowRes,
          resolution,
          isThumbnail: this.player.isThumbnail,
        });
      }
    });
  }

  /**
   * Loads texture onto mesh material from url
   *
   * @param {object} image
   * @param {boolean} flip - whether to flip the texture
   * @param callback
   * @param stereo
   * @param lowRes
   */
  loadTexture(image, flip, callback = () => { }, stereo, lowRes) {
    return new Promise((resolve, reject) => {
      try {
        this.getTexture(
          image,
          flip,
          (texture, full, res) => {
            this.setTexture(texture);
            callback(full, res);
            resolve(texture);
          },
          stereo,
          lowRes,
        );
      } catch (e) {
        callback(false, null);
        reject();
      }
    });
  }
}
